if (!customElements.get('product-feature-panels')) {
  customElements.define('product-feature-panels', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('toggle', event => {
        const panel = event.target;
        if (!panel.matches('[data-panel]') || !panel.open) return;
        this.querySelectorAll('[data-panel]').forEach(other => { if (other !== panel) other.open = false; });
        this.showImage(panel);
      }, { capture: true, signal });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-panel]');
        if (panel) { panel.open = true; this.showImage(panel); }
      }, { signal });
      this.showImage(this.querySelector('[data-panel][open]'));
    }
    showImage(panel) {
      const template = panel?.querySelector('template[data-panel-image]');
      if (template?.content.firstElementChild) this.querySelector('[data-panel-figure]').replaceChildren(template.content.firstElementChild.cloneNode(true));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('product-image-comparison')) {
  customElements.define('product-image-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      // Position lives in --position (CSS clips the before image and moves the divider);
      // the hidden range keeps keyboard and screen reader access.
      const update = () => this.style.setProperty('--position', `${Math.max(0, Math.min(100, Number(range.value) || 0))}%`);
      const fromPointer = event => {
        const rect = this.getBoundingClientRect();
        range.value = String(((event.clientX - rect.left) / rect.width) * 100);
        update();
      };
      range.addEventListener('input', update, { signal });
      this.addEventListener('pointerdown', event => {
        this.dragging = true;
        this.setPointerCapture(event.pointerId);
        fromPointer(event);
      }, { signal });
      this.addEventListener('pointermove', event => { if (this.dragging) fromPointer(event); }, { signal });
      this.addEventListener('pointerup', () => { this.dragging = false; }, { signal });
      this.addEventListener('pointercancel', () => { this.dragging = false; }, { signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

if (!customElements.get('product-results-stats')) {
  customElements.define('product-results-stats', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const track = this.querySelector('[data-results-track]');
      const stats = [...this.querySelectorAll('[data-results-stat]')];
      const progress = this.querySelector('[data-results-progress]');
      if (!track || !stats.length) return;
      // Mobile carousel: the stat nearest the track's center is the active one.
      const update = () => {
        const center = track.getBoundingClientRect().left + track.clientWidth / 2;
        let active = 0;
        let best = Infinity;
        stats.forEach((stat, index) => {
          const rect = stat.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < best) { best = distance; active = index; }
        });
        stats.forEach((stat, index) => stat.classList.toggle('is-active', index === active));
        progress?.parentElement.style.setProperty('--index', String(active));
      };
      track.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
      this.addEventListener('shopify:block:select', event => {
        event.target.closest('[data-results-stat]')?.scrollIntoView({ inline: 'center', block: 'nearest' });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
